import { vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDynamicComponent as _resolveDynamicComponent, KeepAlive as _KeepAlive, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { id: "app" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createVNode($setup["MenuBar"], null, null, 512 /* NEED_PATCH */), [
      [_vShow, _ctx.$route?.meta?.menuBar]
    ]),
    ($setup.showSplash)
      ? (_openBlock(), _createBlock($setup["Splash"], {
          key: 0,
          onHiddenSplash: $setup.hiddenSplash
        }))
      : _createCommentVNode("v-if", true),
    _createCommentVNode(" Keep-alive only for routes with keepAlive meta - Vue 3 compatible syntax "),
    _createVNode(_component_router_view, null, {
      default: _withCtx(({ Component, route }) => [
        (route.meta.keepAlive)
          ? (_openBlock(), _createBlock(_KeepAlive, { key: 0 }, [
              (_openBlock(), _createBlock(_resolveDynamicComponent(Component), {
                key: route.path
              }))
            ], 1024 /* DYNAMIC_SLOTS */))
          : (_openBlock(), _createBlock(_resolveDynamicComponent(Component), {
              key: route.path
            }))
      ]),
      _: 1 /* STABLE */
    }),
    _createVNode($setup["OnScreenDebugger"])
  ]))
}